import React from "react";
import { useNavigate } from "react-router-dom";
import AutoCompleteSearch from "../children/AutoCompleteSearch";
import SelectScrapMaterial from "../children/SelectScrapMaterial";

function SelectScrap() {
  const navigate = useNavigate();
  return (
    <div className="slide-in " style={{ width: "97vw", overflow: "hidden" }}>
      <span
        className="material-icons-outlined pointer pointer cercle-purple-text"
        onClick={() => navigate(-1)}
      >
        arrow_back
      </span>
      <div
        className="p-3 cover flex column gap-3"
        style={{
          width: "80%",
          margin: "auto",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
        }}
      >
        <div className="valign-wrapper space-between">
          <span>
            <h2 className="margin-0px">Hi! Trader, 👋 </h2>
            <p className="font-18px">Welcome to Our Auction Platform</p>
          </span>
          <img
            src="/images/auction-image.png"
            alt="logo"
            style={{ objectFit: "contain", height: "70px" }}
          />
        </div>

        <div className="flex column gap-10px">
          <p className="font-18px">
            Choose or Classify Your Preferred Scraps for Purchase
          </p>
          {/* <AutoCompleteSearch /> */}
          <SelectScrapMaterial />
        </div>
      </div>
    </div>
  );
}

export default SelectScrap;
